import React from "react";
import { Stack, Box, Typography, Divider } from "@mui/material";
import { useScrollToSection } from "~/single-page/hooks/useScrollToSection";

export default function PrivacyPolicyPage() {
  useScrollToSection();

  return (
    <Stack spacing={4} sx={{ maxWidth: '100%' }}>
      <Box>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', mb: 2, mt: 2, textAlign: 'center' }}>
          Política de Privacidade
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 4, textAlign: 'center' }}>
          A privacidade dos nossos usuários é fundamental para nós. Esta Política de Privacidade 
          explica como coletamos, usamos, armazenamos e protegemos suas informações pessoais quando 
          você utiliza a plataforma Bora Impactar.
        </Typography>
      </Box>

      <Divider />
      
      <Box sx={{ maxWidth: '800px', mx: 'auto' }}>
        <Stack spacing={4}>
          {/* Seção 1 */}
          <Box>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2, color: '#1B4B72' }}>
              1. Informações que Coletamos
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Coletamos informações que você nos fornece diretamente, como:
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Nome, e-mail e outras informações de contato
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Informações sobre sua organização (se aplicável)
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Dados de participação em ações e eventos
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Informações de comunicação conosco
              </Typography>
            </Box>
          </Box>

          {/* Seção 2 */}
          <Box>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2, color: '#1B4B72' }}>
              2. Como Usamos suas Informações
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Utilizamos suas informações para:
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Fornecer e melhorar nossos serviços
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Facilitar a participação em ações sociais
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Comunicar sobre oportunidades de voluntariado
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Enviar notificações importantes sobre nossa plataforma
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Garantir a segurança e integridade da plataforma
              </Typography>
            </Box>
          </Box>

          {/* Seção 3 */}
          <Box>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2, color: '#1B4B72' }}>
              3. Compartilhamento de Informações
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros para 
              fins comerciais. Podemos compartilhar informações apenas:
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Com seu consentimento explícito
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Para cumprir obrigações legais
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Para proteger nossos direitos e segurança
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Com organizações parceiras, apenas quando necessário para a execução de ações sociais
              </Typography>
            </Box>
          </Box>

          {/* Seção 4 */}
          <Box>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2, color: '#1B4B72' }}>
              4. Segurança dos Dados
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Implementamos medidas de segurança técnicas e organizacionais adequadas para proteger 
              suas informações pessoais contra acesso não autorizado, alteração, divulgação ou destruição.
            </Typography>
          </Box>

          {/* Seção 5 */}
          <Box>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2, color: '#1B4B72' }}>
              5. Seus Direitos
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Você tem o direito de:
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Acessar suas informações pessoais
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Corrigir dados incorretos ou desatualizados
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Solicitar a exclusão de suas informações
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Retirar seu consentimento a qualquer momento
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                Solicitar a portabilidade dos seus dados
              </Typography>
            </Box>
          </Box>

          {/* Seção 6 */}
          <Box>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2, color: '#1B4B72' }}>
              6. Cookies e Tecnologias Similares
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Utilizamos cookies e tecnologias similares para melhorar sua experiência na plataforma, 
              analisar o uso do site e fornecer conteúdo personalizado.
            </Typography>
          </Box>

          {/* Seção 7 */}
          <Box>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2, color: '#1B4B72' }}>
              7. Retenção de Dados
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Mantemos suas informações pessoais apenas pelo tempo necessário para cumprir os 
              propósitos descritos nesta política ou conforme exigido por lei.
            </Typography>
          </Box>

          {/* Seção 8 */}
          <Box>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2, color: '#1B4B72' }}>
              8. Alterações nesta Política
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos sobre 
              mudanças significativas através da plataforma ou por e-mail.
            </Typography>
          </Box>

          {/* Seção 9 */}
          <Box>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2, color: '#1B4B72' }}>
              9. Contato
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Se você tiver dúvidas sobre esta Política de Privacidade ou sobre como tratamos suas 
              informações pessoais, entre em contato conosco através do nosso canal de atendimento.
            </Typography>
          </Box>

          {/* Data de atualização */}
          <Box sx={{ textAlign: 'center', mt: 4, pt: 2, borderTop: '1px solid #eee' }}>
            <Typography variant="body2" color="text.secondary">
              {/* Última atualização: {new Date().toLocaleDateString('pt-BR')} */}
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
} 